module.exports = __webpack_public_path__ + "img/saintbrand-infinite-marquee.7c35f4aa.png";